import guards from '../guards.js';

const load = (page) => {
  return() => import(`@/pages/${page}/${page}.vue`);
}

const publicRoutes = {
  path: '/public/:company',
  component: () => import(`@/layouts/PublicLayout/PublicLayout.vue`),
  meta: {
    isCompanySwitchingZone: true,
    zone: 'public',
  },
  //beforeEnter: guards.redirectIfAuthenticated,
  meta: {
    isCompanySwitchingZone: true,
    zone: 'public',
  },
  children: [
    {
      name: 'home',
      path: '',
      component: load('Home'),
      alias: '/accueil',
    },
    {
      name: 'login',
      path: 'connexion',
      component: load('Login'),
      alias: '/connexion',
    },
    {
      name: 'updatePassword',
      path: 'set-password',
      component: load('UpdateNewAdvPassword'),
      alias: '/set-password',
    },
    {
      name: 'sign-up',
      path: 'sign-up',
      component: load('Signup'),
      alias: '/sign-up',
    },
    {
      name: 'browse-missions',
      path: 'missions',
      component: load('Missions'),
    },
    {
      name: 'public-mission',
      path: 'mission-exemple',
      component: load('Mission'),
    },
    {
      name: 'email-confirmation',
      path: 'email-confirmation',
      component: load('EmailConfirmation'),
    },
    {
      name: 'impersonate',
      path: 'impersonate',
      component: load('Impersonate'),
    },
    {
      name: 'registeration-confirmation',
      path: 'confirmation-inscription',
      component: load('SignupConfirmation'),
    },
    {
      name: 'job-offer-details',
      path: 'offre-emploi-details',
      component: load('JobOfferDetails'),
    },
    {
      name: 'jobs',
      path: 'jobs',
      component: load('Missions'),
    },
    {
      name: 'remove',
      path: 'remove',
      component: load('RemoveCandidate'),
    },
    {
      name: 'privacy-policy',
      path: 'politique-confidentialite',
      component: () => import(`@/pages/PrivacyPolicy/PrivacyPolicy.vue`),
    },
  ]
};

export default publicRoutes;
